import ajax from "@fdaciuk/ajax";

export default {
    init() {
    },
    finalize() {

        jQuery(document).ready(function() {
            document.addEventListener('click', function(event) {
                if (event.target.classList.contains("next-posts-link")) {
                    event.preventDefault();
                    event.target.classList.add('waiting');
                    loadMore(event.target.href);
                }
            });
        });

        function loadMore(href) {

            // Check we have the containers so we know where to insert ajax'd data...
            const site_posts_navigation = document.getElementById('post_navigation');
            const site_posts_container = document.querySelector('.r--posts');

            if (href && site_posts_navigation && site_posts_container) {

                // get next page via ajax
                ajax().get(href).then(function(response, xhr) {
                    
                    const faker = document.createElement('div');
                    faker.innerHTML = response;
                    let posts_navigation = faker.querySelector('#post_navigation');
                    let posts = faker.querySelectorAll('.c--post');

                    // append new posts to page
                    for (let i=0; i < posts.length; i++) {
                        site_posts_container.appendChild(posts[i]);
                    }

                    // replace old posts with new pagination
                    site_posts_navigation.innerHTML = posts_navigation.innerHTML;
                })
            }

        }
    }
};



// WEBPACK FOOTER //
// ./js/routes/blog.js